<template>
  <div class="main">
    <div :style="{ width: paddingAuto}"></div>
    <div class="content">
      <div class="bg-video" v-for="item in videoList">
        <div class="video">
          <video controls :poster="item.img">
            <source :src="item.url" type="video/mp4">
          </video>
        </div>
        <div class="title">
          <div class="title-txt">{{ item.title }}</div>
          <div><img src="../../assets/user.png" alt="" style="width: 30px; height: 35px"></div>
        </div>
        <div class="content-txt">
          {{ item.content1 }}<br/>{{ item.content2 }}
        </div>
      </div>
    </div>
    <div :style="{ width: paddingAuto}"></div>
  </div>
</template>

<script>
export default {
  name: "clients",
  components: {},
  props: {},
  computed: {},
  watch: {
    screenWidth: function (n, o) {
      if (n >= 1440) this.paddingAuto = 200 + 'px';
      if (n >= 1280 && n < 1440) this.paddingAuto = 200 - (1440 - n) + 'px';
      if (n < 1280) this.paddingAuto = 40 + 'px';
    },
    "$route.query.zh": {
      immediate: true, // 第一次的数据，也要当做是一种变化
      // 处理函数（不能修改名字） handler('新的值'，'旧的值')
      handler(new_value, old_value) {
        this.zh = new_value;
        if (this.zh === 'ja') {
          this.videoList = this.videoListJa;
        } else {
          this.videoList = this.videoListEn;
        }
      },
    },
  },
  data() {
    return {
      paddingAuto: null,
      screenWidth: null,
      videoList: [],
      videoListEn: [
        { name: 0, title: 'Grandeur Tech & IT Services, Lagos', img: require('../../assets/carousel-1.jpg'), url: require('../../assets/video/3205.mp4'), content1: "Grandeur Tech & IT Services is a printing, graphics designing and computer training centre based in Lagos Nigeria. Prior to purchasing our solar system, they will spend around $10-$15 on their two generator set to make sure they get enough electricity needed for their daily business activities.",
            content2: "Beyond eradicating the noise pollution and carbon monoxide the Genset produce, we've also helped Grandeur to save hundreds dollars every month as they no longer need to own generator set nor purchase fuel daily."},
        { name: 1, title: 'True Vine Hospital', img: require('../../assets/carousel-2.jpg'), url: require('../../assets/video/3206.mp4'), content1: "True Vine Hospital is located in one of the developing areas in Lagos State. The locality has a nearly 15,000 residents with extremely poor water, road and electricity conditions. Our research showed that the hospital and the entire locality only get a 30mins light once every six months. Before Solarchain, the hospital relied on three gensets which they had to rotate on a need basis and will keep all generator sets on standby during operations. The hospital spend around $20 - $35 daily just to make sure that they are able serve their patient properly.",
            content2: "The presence of Solarchain have helped changed the narrative for True Vine Hospital, as they no longer have to rely on generators, or other tedious means of electricity. It's now easier for them to treat patients irrespective of the time."},
        { name: 2, title: 'Mrs. Ogundoyin', img: require('../../assets/carousel-3.jpg'), url: require('../../assets/video/3207.mp4'), content1: "Mrs Ogundoyin and her family lives in Gbetu community. This community have not witnessed grid electricity for the past nine years, hence all residents (about 4,500 population) have to source for alternative electricity supply. At least 98% of the population rely on generators to generate electricity. Beyond the side effects that the pollution from running a generator set creates, the residents always have to battle fuel and maintenance cost daily. This makes the cost of living super high amongst residents.",
            content2: "As a result, the family of Ogundoyin decided to try out the Solarchain 3KVA system suitable for households like hers. Today, Mrs Ogundoyin and her family feel a sigh of relief as they have not just succeeded in drastically reducing the high cost of generating electricity through generator sets, they now enjoy a cleaner environment free from noise and carbon pollution."},
      ],
      videoListJa: [
        { name: 0, title: 'Grandeur Tech & IT Services, Lagos', img: require('../../assets/carousel-1.jpg'), url: require('../../assets/video/3205.mp4'), content1: "Grandeur Tech & IT Services社は、ナイジェリアのラゴスに拠点を置く印刷、グラフィックデザイン、コンピュータートレーニングセンターである。ソーラーシステムを導入する前は、日々の業務に必要な電力を確保するために、発電機2台に10ドルから15ドルほど支払っていた。",
          content2: "しかし、ソーラーシステムを導入したことで、騒音公害や一酸化炭素の発生を防ぐだけでなく、発電機の所有費用や燃料の日常的な購入費用が不要になり、毎月数百ドルを節約できるようになった。"},
        { name: 1, title: 'True Vine Hospital', img: require('../../assets/carousel-2.jpg'), url: require('../../assets/video/3206.mp4'), content1: "True Vine病院は、ラゴス州の発展途上地域に位置している。この地域には約15,000人の住民が住んでおり、水道、道路、電力供給の状況は非常に悪化している。弊社の調査によれば、病院とその地域全体では、半年に一度、たった30分の照明しか利用できない状況だった。ソラーチェインが導入される前は、病院は3台の発電機に頼っており、必要に応じてこれらの発電機を切り替えていた。病院は、患者に適切な医療サービスを提供できるために、毎日約20ドルから35ドルを電力供給に費やしていた。",
          content2: "ソラーチェインの導入により、True Vine病院はもはや発電機や他の手間のかかる電力供給手段に頼る必要がなくなり、その物語が変わる手助けをしている。今では時間に制約されずに患者の治療を容易に行うことができるようになった。"},
        { name: 2, title: 'Mrs. Ogundoyin', img: require('../../assets/carousel-3.jpg'), url: require('../../assets/video/3207.mp4'), content1: "Ogundoyinさん一家は、Gbetuコミュニティに住んでいる。このコミュニティでは、過去9年間、送電網による電力供給を受けていないため、全住民（人口約4,500人）は代替電力を調達しなければならない。少なくとも人口の98％は発電機に頼っている。発電機の稼働による公害という副作用に加え、住民たちは毎日、燃料費とメンテナンス費と戦わなければならない。そのため、住民の生活費は超高額になる。",
          content2: "その結果、オグンドインさん一家は、彼女のような家庭に適したソラーチャインの3KVAシステムを試してみることにした。現在、オグンドインさん一家は、発電機による高い発電コストを大幅に削減できただけでなく、騒音や炭素汚染のないクリーンな環境を実現している。"},
      ],
      zh: ''
    }
  },
  methods: {
    testAxios() {
      this.axios({
        method: 'get',//post
        url: '',
        params: {}//data: {}
      }).then((response) => {
        const result = response.data;
        if (result.code === 0) {
        } else {
        }
      })
    },
  },
  mounted() {
    this.screenWidth = document.body.clientWidth
    if (this.screenWidth >= 1440) this.paddingAuto = 200 + 'px';
    if (this.screenWidth >= 1280 && this.screenWidth < 1440) this.paddingAuto = 200 - (1440 - this.screenWidth) + 'px';
    if (this.screenWidth < 1280) this.paddingAuto = 40 + 'px';
    // console.log(this.paddingAuto);
    window.onresize = () => {
      //屏幕尺寸变化
      return (() => {
        this.screenWidth = document.body.clientWidth
      })()
    }
  }
}
</script>

<style lang="less" scoped>
  video{
    width: 100%;
    height: 97%;
    //object-fit: contain;
    object-fit: cover;
    object-position: center center;
    outline: none !important;
  }
  video:focus {
    outline: none !important;
  }

  .main {
    width: 100%;
    height: 3170px;
    background: url('../../assets/clients-bg.png') no-repeat center;
    background-size: cover;
    display: flex;
    justify-content: space-between;
  }

  .content {
    display: flex;
    flex-direction: column;
    margin-top: 192px;

    .bg-video {
      width: 1040px;
      //height: 818px;
      margin-bottom: 56px;
      background: rgba(#FFFFFF, 0.2);
      border-radius: 14px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      .video {
        width: 870px;
        margin-top: 69px;
        font-size: 0;
      }
      .title {
        margin-top: 42px;
        width: 870px;
        //height: 31px;
        display: flex;
        justify-content: space-between;

        .title-txt {
          font-family: 'PP Neue Machina',serif;
          font-style: normal;
          font-weight: 800;
          font-size: 28px;
          line-height: 109%;
          background: linear-gradient(89.87deg, #25BBDE -4.17%, #11ECA0 99.92%), #FFFFFF;-webkit-background-clip: text;-webkit-text-fill-color: transparent;background-clip: text;text-fill-color: transparent;
          //color: #3CD3F7;
        }
      }
      .content-txt {
        margin-top: 32px;
        margin-bottom: 40px;
        width: 870px;
        //height: 123px;

        font-family: 'Poppins-R',serif;
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        line-height: 155%;
        color: #FFFFFF;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/pc/clients.vue